module.exports = __webpack_public_path__ + "static/media/promo.d02141e5.jpg";